import { FileErrors } from 'home/view/check-feasibility/comp-generator/common-interface';

export const validateFile = (fileList: FileList, size: number): string => {
  let error = '';

  Array.from(fileList).forEach((file: File) => {
    const isSizeValid = Math.ceil(file?.size / 1024 / 1024) <= size;

    if (!isSizeValid) {
      error = FileErrors.size;
    }
  });

  return error;
};
